<template>
  <div id="app">
    <admin-layout v-if="$route.name && $route.name.startsWith('admin')" />
    <user-layout v-else />
  </div>
</template>

<script>
import adminLayout from './components/layout/admin/';
import userLayout from './components/layout/user/';

export default {
  name: 'App',

  components: {
    adminLayout,
    userLayout,
  },

};
</script>
